import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'ngx-webstorage';
import { FormControl, FormGroup, Validators } from '@angular/forms';
var CartDatesPromptComponent = /** @class */ (function () {
    function CartDatesPromptComponent(activeModal, localSt) {
        this.activeModal = activeModal;
        this.localSt = localSt;
        this.datesArray = [];
        this.dates = [];
    }
    CartDatesPromptComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.createForm();
        if (this.localSt.retrieve('cartDates')) {
            if (this.localSt.retrieve('suggestedItemEndDate') && this.localSt.retrieve('suggestedItemEndDate') !== null) {
                this.datesArray = this.localSt.retrieve('cartDates');
                this.datesArray.forEach(function (date) {
                    if (new Date(date).toISOString() <= _this.localSt.retrieve('suggestedItemEndDate')) {
                        _this.dates.push(date);
                    }
                });
            }
            else {
                this.dates = this.localSt.retrieve('cartDates');
            }
            this.datesForm.patchValue({ date: this.dates[0] });
        }
    };
    CartDatesPromptComponent.prototype.createForm = function () {
        this.datesForm = new FormGroup({
            date: new FormControl('', [Validators.required])
        });
    };
    CartDatesPromptComponent.prototype.closeModal = function (status) {
        this.localSt.clear('cartDates');
        this.localSt.clear('suggestedItemEndDate');
        this.activeModal.close({ status: status, date: this.datesForm.value.date });
    };
    return CartDatesPromptComponent;
}());
export { CartDatesPromptComponent };



// WEBPACK FOOTER //
// ./src/app/modules/shared/cart-dates-prompt/cart-dates-prompt.component.ts.pre-build-optimizer.js